import {
    type GetAllNewsResponseType,
    type GetAllNewsRequestType
} from "./type";
import {
    request
} from "../request";

const GetAllNews = async (params: GetAllNewsRequestType): Promise<GetAllNewsResponseType> => {
    return await request<GetAllNewsResponseType>("/news/getAllNews", {
        body: JSON.stringify(params),
        method: "POST"
    });
};

export default GetAllNews;
